import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { VoipCurrent } from "@/shared/utils/interfaces";
import { useQuery } from "@tanstack/react-query";

const useVoipCurrentQuery = () => {
  const extension = "0200";
  const branchId = useBranchId();
  const queryKey = ["voipcurrent", branchId, extension];

  const query = useQuery<VoipCurrent>({
    queryKey: queryKey,
    queryFn: () =>
      get2(`internal/secure/pos/v1/voip/current/${branchId}/${extension}`),
    enabled: false,
    refetchOnWindowFocus: false,
  });

  return { ...query, queryKey };
};

export default useVoipCurrentQuery;
